/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { Grid } from '@elliemae/ds-grid';
import { __UNSAFE_SPACE_TO_DIMSUM, op, styled, withTheme } from '@elliemae/ds-system';
import { DSFullPageContainer, DSFullPageContainerScroll } from '../FullPageContainer/index.js';

const PageTitleWrapper = styled(Grid)`
  min-height: 44px;
`;

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const DSMobilePageList = withTheme(
  ({ header = null, pageTitle = null, filterBar = null, body = null, footer = null, theme }) => {
    const rows = [];
    if (header) rows.push(__UNSAFE_SPACE_TO_DIMSUM(theme.space.xxl));
    if (pageTitle) rows.push('auto');
    if (filterBar) rows.push(op('*', __UNSAFE_SPACE_TO_DIMSUM(theme.space.xl), 0.83));
    rows.push(1);
    if (footer) rows.push('56px');
    return (
      <DSFullPageContainer rows={rows}>
        {header ? <Grid>{header}</Grid> : null}
        {pageTitle ? <PageTitleWrapper>{pageTitle}</PageTitleWrapper> : null}
        {filterBar ? <Grid>{filterBar}</Grid> : null}
        <DSFullPageContainerScroll>{body}</DSFullPageContainerScroll>
        {footer && <Grid>{footer}</Grid>}
      </DSFullPageContainer>
    );
  },
);

const DSPageList = DSMobilePageList;

export { DSMobilePageList, DSPageList };
